import { useEffect, useState } from 'react'
import moment from 'moment'
import { isFunction } from 'lodash'

const localStorage = window.localStorage

/** @deprecated 2025-04-29 */
const useLocalStorageOld = (storageKey, fallbackState, getDate = false) => {
  const [value, setValue] = useState(storageKey && localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : fallbackState)

  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify(value))
    }
  }, [value, storageKey])

  return !getDate ? [value, setValue] : [moment(value), setValue]
}

export default useLocalStorageOld

/** @param {?function} factory - Applied to the initial value, stored or fallback, before the first render. */
export const useLocalStorage = (storageKey, fallbackState, factory = null) => {
  const [value, setValue] = useState(() => {
    const initialValue = storageKey && localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : fallbackState

    return isFunction(factory) ? factory(initialValue) : initialValue
  })

  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify(value))
    }
  }, [value, storageKey])

  return [value, setValue]
}
